import type { ReactNode } from "react";
import { useSearchParams } from "react-router";
import { WayflyerError } from "shared-ui";

import { FINANCIAL_DOCUMENTS_STEP_ID } from "../../hooks/navigation-next";
import { UploadDocumentType } from "../../types";

import {
  BalanceSheetDocumentUploadPage,
  CashFlowForecastDocumentUploadPage,
  DebtAgreementsDocumentUploadPage,
  FinancialDocumentsUploadPage,
  ManagementAccountsDocumentUploadPage,
  ProfitAndLossDocumentUploadPage,
  SusaDocumentUploadPage,
} from "./document-uploads-pages";

const DocumentUploadComponents: Record<string, ReactNode> = {
  [UploadDocumentType.SUSA]: <SusaDocumentUploadPage />,
  [FINANCIAL_DOCUMENTS_STEP_ID]: <FinancialDocumentsUploadPage />,
  // Legacy alias so old `?document=pool-bancario` links still resolve.
  [UploadDocumentType.POOL_BANCARIO]: <FinancialDocumentsUploadPage />,
  [UploadDocumentType.COMPANY_DEBT_AGREEMENT]: <DebtAgreementsDocumentUploadPage />,
  [UploadDocumentType.CASH_FLOW_FORECAST]: <CashFlowForecastDocumentUploadPage />,
  [UploadDocumentType.MANAGEMENT_ACCOUNTS]: <ManagementAccountsDocumentUploadPage />,
  [UploadDocumentType.PROFIT_AND_LOSS]: <ProfitAndLossDocumentUploadPage />,
  [UploadDocumentType.BALANCE_SHEET]: <BalanceSheetDocumentUploadPage />,
};

export const DocumentUploadManager = () => {
  const [searchParams] = useSearchParams();

  const pagesCollection = DocumentUploadComponents;
  const document = searchParams.get("document");

  if (!document || !(document in pagesCollection)) {
    throw new WayflyerError("Missing or unknown document type", "404");
  }

  return pagesCollection[document];
};
